<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.pc_code }}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="pc_history">
            <label class="weui-form-preview__label">{{customLabel.pc_history || "变更内容"}}</label>
            <em class="weui-form-preview__value">{{
              form.main.pc_history
            }}</em>
          </div>
          <div class="weui-form-preview__item" slot="pj_code">
              <label class="weui-form-preview__label">{{customLabel.pj_code || "项目单号"}}</label>
              <span class="weui-form-preview__value">{{
                 form.main.pj_code
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pj_dename">
              <label class="weui-form-preview__label">{{customLabel.pj_dename || "项目名称"}}</label>
              <span class="weui-form-preview__value">{{
                 form.main.pj_dename
              }}</span>
            </div>
            <change-field
              slot="项目分类"
              label="项目分类"
              :old-value="form.main.pc_project_classify"
              :new-value="form.main.pj_project_classify"
            />
            <change-field
              slot="项目等级"
              label="项目等级"
              :old-value="form.main.pc_project_level"
              :new-value="form.main.pj_project_level"
            />
            <change-field
              slot="产品类型"
              label="产品类型"
              :old-value="form.main.dc_product_type_old"
              :new-value="form.main.dc_product_type_new"
            />
            <change-field
              slot="项目负责人"
              label="项目负责人"
              :old-value="form.main.pc_emname"
              :new-value="form.main.pj_emname"
            />
            <change-field
              slot="计划开始时间"
              label="计划开始时间"
              :old-value="form.main.pc_begin_date"
              :new-value="form.main.pj_begin_date"
            />
            <change-field
              slot="计划完成时间"
              label="计划完成时间"
              :old-value="form.main.pc_end_date"
              :new-value="form.main.pj_end_date"
            />
            <change-field
              slot="预算金额"
              label="预算金额"
              :old-value="form.main.pc_budget"
              :new-value="form.main.pj_budget"
            />
        </custom-layout>
      </div>
      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items1"
          :key="item.id"          
        >
          <div class="form-detail-preview_num">主要参数-行号{{ item.pp_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="ppc_type">
              <label class="weui-form-preview__label">{{customLabel.ppc_type || "操作类型"}}</label>
              <span class="weui-form-preview__value">{{
                 item.ppc_type
              }}</span>
            </div>
            <change-field
              slot="参数名称"
              label="参数名称"
              :old-value="item.ppc_name"
              :new-value="item.pp_name"
            />
            <change-field
              slot="参数值"
              label="参数值"
              :old-value="item.ppc_value"
              :new-value="item.pp_value"
            />
          </custom-layout>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items2"
          :key="item.id"          
        >
          <div class="form-detail-preview_num">研发阶段-行号{{ item.pp_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail2">
            <div class="weui-form-preview__item" slot="ppc_type">
              <label class="weui-form-preview__label">{{customLabel.ppc_type || "操作类型"}}</label>
              <span class="weui-form-preview__value">{{
                 item.ppc_type
              }}</span>
            </div>
            <change-field
              slot="研发阶段"
              label="研发阶段"
              :old-value="item.ppc_rpname"
              :new-value="item.pp_rpname"
            />
            <change-field
              slot="阶段负责人"
              label="阶段负责人"
              :old-value="item.ppc_emname"
              :new-value="item.pp_emname"
            />
            <change-field
              slot="联系电话"
              label="联系电话"
              :old-value="item.ppc_emname"
              :new-value="item.pp_emname"
            />
            <change-field
              slot="开始日期"
              label="开始日期"
              :old-value="item.ppc_emname"
              :new-value="item.pp_emname"
            />
            <change-field
              slot="完成日期"
              label="完成日期"
              :old-value="item.ppc_emname"
              :new-value="item.pp_emname"
            />
          </custom-layout>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items3"
          :key="item.id"          
        >
          <div class="form-detail-preview_num">任务安排-行号{{ item.pp_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail3">
            <div class="weui-form-preview__item" slot="tc_type">
              <label class="weui-form-preview__label">{{customLabel.tc_type || "操作类型"}}</label>
              <span class="weui-form-preview__value">{{
                 item.tc_type
              }}</span>
            </div>
            <change-field
              slot="研发阶段"
              label="研发阶段"
              :old-value="item.tc_ta_rpname"
              :new-value="item.ta_rpname"
            />
            <change-field
              slot="任务节点名称"
              label="任务节点名称"
              :old-value="item.tc_ta_task"
              :new-value="item.ta_task"
            />
            <change-field
              slot="岗位"
              label="岗位"
              :old-value="item.tc_ta_role"
              :new-value="item.ta_role"
            />
            <change-field
              slot="任务责任人"
              label="任务责任人"
              :old-value="item.tc_ta_emname"
              :new-value="item.ta_emname"
            />
            <change-field
              slot="联系电话"
              label="联系电话"
              :old-value="item.tc_ta_emtel"
              :new-value="item.ta_emtel"
            />
            <change-field
              slot="工时"
              label="工时"
              :old-value="item.tc_ta_planworkhour"
              :new-value="item.ta_planworkhour"
            />
            <change-field
              slot="开始日期"
              label="开始日期"
              :old-value="item.tc_ta_planbegindate"
              :new-value="item.ta_planbegindate"
            />
            <change-field
              slot="完成日期"
              label="完成日期"
              :old-value="item.tc_ta_planenddate"
              :new-value="item.ta_planenddate"
            />
          </custom-layout>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import ChangeField from "@/components/field/ChangeField";
import form from "@/mixins/form.js";

export default {
  components: {
    CustomLayout,
    ChangeField
  },
  mixins: [form],
  data() {
    return {
      baseUrl: "/api/plm/projchange",
    };
  }
}
</script>